
import { AdmService } from 'src/app/shared/services/adm.service';
import { Component } from '@angular/core';
import { ConfigService } from '../../shared/services/config.service';
import { forkJoin } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { isMobile, passwordValidator } from '../../shared/utils/helpers';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { UsuariosService } from 'src/app/shared/services/usuarios.service';
import { JwtHelperService } from '@auth0/angular-jwt';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html'
})

export class LoginComponent {
    email: string = "";
    emailvalido = "";
    hide = true;
    hide1 = true;
    form: FormGroup;

    public Validaciones: {
        EscribirClave: string
        EscribirUsuarioRed: string
    }

    public Etiquetas: {
        Boton: string
        Clave: string
        CorreoElectronico: string,
        LeadText1: string
        LeadText2: string
        LeadText3: string
        LeadText4: string
        MailContacto: string
        SolicitudClaveNueva: string
        VerificarCuenta: string
        Ayuda: string;
        LogoBayerBlanco: string
        LogoBayerColor: string
    }

    public Tooltips: {
        SolicitudClaveNueva: string
    }
    redirectUrl: any;

    constructor(
        private admService: AdmService,
        private fb: FormBuilder,
        private loggedService: LoggedService,
        private router: Router,
        private usuarioService: UsuariosService,
        public configService: ConfigService,
        private snackBarService: SnackbarService,
        private jwtService: JwtHelperService,
        private activatedRoute: ActivatedRoute) {
        this.Validaciones = {
            EscribirClave: this.configService.validaciones.Login.EscribirClave,
            EscribirUsuarioRed: this.configService.validaciones.Login.EscribirUsuarioRed
        }
        this.Etiquetas = {
            Boton: this.configService.etiquetas.Login.Boton,
            Clave: this.configService.etiquetas.Login.Clave,
            CorreoElectronico: this.configService.etiquetas.Login.CorreoElectronico,
            LeadText1: this.configService.etiquetas.Login.LeadText1,
            LeadText2: this.configService.etiquetas.Login.LeadText2,
            LeadText3: this.configService.etiquetas.Login.LeadText3,
            LeadText4: this.configService.etiquetas.Login.LeadText4,
            MailContacto: this.configService.etiquetas.MailContacto,
            SolicitudClaveNueva: this.configService.etiquetas.Login.SolicitudClaveNueva,
            Ayuda: this.configService.etiquetas.Login.Ayuda,
            VerificarCuenta: this.configService.etiquetas.Login.VerificarCuenta,
            LogoBayerBlanco: this.configService.etiquetas.LogoBayerBlanco,
            LogoBayerColor: this.configService.etiquetas.LogoBayerColor
        }
        this.Tooltips = {
            SolicitudClaveNueva: this.configService.tooltips.Login.SolicitudClaveNueva

        }
        this.form = this.fb.group({
            UserName: ['', [Validators.required]],
            Password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(15), passwordValidator]]
        });
    }

    ngOnInit() {       

        const token = localStorage.getItem('PortalCS');
        if (token && !this.jwtService.isTokenExpired(token)) {
            localStorage.setItem('logoutLogs', JSON.stringify({
                timestamp: new Date(),
                reasonId: 0,
                source: 'login.component.ts'
            }));
            this.loggedService.logOut(0);
        }

        this.loggedService.cModulosSideNav();
        this.activatedRoute.queryParams.subscribe(params => {
            this.redirectUrl = params['redirectUrl'] || null;
          });
        
    }
    isLogged() {
        return this.loggedService.logged != null;
    }

    emailValidator() {

        const regularExpresion = "^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";


    }



    onSubmit() {

        this.activatedRoute.queryParams.subscribe(params => {
            this.redirectUrl = params['redirectUrl'] || null;
          });
        this.usuarioService
            .login(this.form.value)
            .subscribe(
                (data: any) => {
                    const token = data.token;
                    const tokenBearer = data.tokenBearer;
                    this.loggedService.setToken(token);
                    this.loggedService.setLogged(token);
                    this.loggedService.setTokenBearer(tokenBearer);
                // this.router.navigateByUrl('');
                if (this.redirectUrl != null){
                this.redirectUrl = this.redirectUrl.split('#')[1];
                this.redirectUrl = this.redirectUrl == '/login'? null : this.redirectUrl;

                }
                const tokenp = localStorage.getItem('PortalCS');
                const helper = new JwtHelperService();

                if (tokenp) {
                    const expiration = helper.getTokenExpirationDate(tokenp);
                    const isExpired = helper.isTokenExpired(tokenp);
                    console.log('Token expira:', expiration);
                    console.log('Fecha actual:', new Date());
                    console.log('¿Token expirado?', isExpired);
                }
                this.router.navigateByUrl(this.redirectUrl || '');

                });



    }

    olvidoClave() {

        this.usuarioService.cNuevaClave(this.form.value).subscribe(() => {
            this.snackBarService.openSnackbar(this.configService.mensajes.TituloInfo, this.configService.mensajes.LoginUsuario.VerificarCuenta, 2, 1);
        });


    }

    get userName() {
        return this.form.get('UserName');
    }
    get password() {
        return this.form.get('Password');
    }

    clearUsername() {
        this.form.controls['UserName'].setValue('');
        this.form.controls['UserName'].markAsUntouched();
    }

    isMobile() {
        return isMobile();
    }
    irAPantallaVerificacion() {
        this.router.navigateByUrl(this.configService.etiquetas.VerificarCuenta.Path);
    }
}
